import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgCode = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 42 32",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fillRule: "evenodd",
		children: [/* @__PURE__ */ _jsx("path", {
			fill: "inherit",
			d: "M28.049808 23.649807L35.184038 16.5l-7.13423-7.149808 2.196346-2.196346L39.592307 16.5l-9.346153 9.346154zM14.373269 23.649807L7.239039 16.5l7.13423-7.149808-2.196346-2.196346L2.83077 16.5l9.346153 9.346154z"
		}), /* @__PURE__ */ _jsx("path", {
			fill: "inherit",
			fillRule: "nonzero",
			d: "M22.976923 3h3.634616l-7.788462 27H15.18846z"
		})]
	})
});
export default SvgCode;
